// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSuccessIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m15.47-2.712a1.25 1.25 0 0 0-1.94-1.576l-5.51 6.782-1.535-1.963a1.25 1.25 0 0 0-1.97 1.539l1.727 2.21a2.25 2.25 0 0 0 3.52.034z"
    />
  </g>
);
export default SvgSuccessIcon;
SvgSuccessIcon.displayName = 'SvgSuccessIcon';
